import { useCallback } from "react";
import { useParams, useLocation } from "react-router-dom";

/**
 * Hook que retorna helpers para navegar preservando o slug do tenant no path.
 *
 *   const t = useTenantPath();
 *   t("/fila")     → "/lerose/fila"
 *   t.slug         → "lerose"
 *
 * Se não houver slug (rotas globais como /super/*), retorna o próprio caminho.
 */
export default function useTenantPath() {
  const params = useParams();
  const loc = useLocation();
  let slug = params.tenantSlug;
  if (!slug) {
    const first = (loc.pathname.split("/").filter(Boolean)[0] || "").toLowerCase();
    if (first && !["super", "api", "static", "assets"].includes(first)) slug = first;
  }

  const build = useCallback(
    (path) => {
      if (!slug) return path;
      if (!path) return `/${slug}`;
      const p = path.startsWith("/") ? path : `/${path}`;
      return `/${slug}${p}`;
    },
    [slug],
  );

  build.slug = slug || null;
  return build;
}
